import { ChangeEvent } from 'react';

import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { IconFile } from 'UIPackage/IconsModule/components/IconFile';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IKnmDocumentsTableColumn } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmDocumentsTableColumn';
import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import { IKnmAttachmentWithType } from '../interfaces/IKnmAttachmentWithType';
import { knmDocumentsTableColumns } from '../constants/knmDocumentsTableColumns';
import styles from './KnmDocumentsModalTable.module.scss';

interface IKnmDocumentsModalTableProps {
  documents?: IKnmAttachmentWithType[];
  itemsCheck: TableCheckItems;
  isCheckboxAllChecked: boolean;
  handleTableCheckboxAllChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleTableCheckboxChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const KnmDocumentsModalTable = ({
  documents,
  itemsCheck,
  isCheckboxAllChecked,
  handleTableCheckboxAllChange,
  handleTableCheckboxChange,
}: IKnmDocumentsModalTableProps) => {
  const renderRow = () => {
    if (documents && documents.length) {
      return documents.map(el => (
        <tr className={styles.Row} key={el.guid}>
          <td className={styles.TbodyCell}>
            <Checkbox
              id={el.guid || undefined}
              theme="system"
              onChange={handleTableCheckboxChange}
              checked={el.guid ? itemsCheck[el.guid] : false}
            />
            <IconFile margin="left" fileName={el.fileName || ''} />
          </td>
          <td className={styles.TbodyCell}>{el.type}</td>
          <td className={styles.TbodyCell}>{el.fileName}</td>
          <td className={styles.TbodyCell}>
            {formatDate({ date: el.dateCreate || '', dateFormat: DATE_FORMAT_LONG_FNS })}
          </td>
          <td className={styles.TbodyCell}>
            <div className={el.signed ? styles.DocumentSigned : styles.DocumentNotSigned} />
            <div className={styles.SignInfo}>
              {el.signed && el.signatureInfo
                ? el.signatureInfo.map((info, idx) => {
                    return (
                      <span key={info.signatureId || idx}>
                        {info.certInfo?.issuer?.name}-
                        {formatDate({ date: info.certInfo?.validFrom, dateFormat: DATE_FORMAT_LONG_FNS })}
                      </span>
                    );
                  })
                : null}
            </div>
          </td>
        </tr>
      ));
    }
  };

  return (
    <table className={styles.Table}>
      <thead className={styles.Thead}>
        <tr className={styles.Row}>
          <th className={styles.TheadCell}>
            <Checkbox
              id="documents-check-all"
              theme="system"
              onChange={handleTableCheckboxAllChange}
              checked={isCheckboxAllChecked}
            />
          </th>
          {knmDocumentsTableColumns.map((col: IKnmDocumentsTableColumn) => {
            return (
              <th className={styles.TheadCell} key={col.id}>
                {col.name}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody className={styles.Tbody}>{renderRow()}</tbody>
    </table>
  );
};
